/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DropDown/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function DropDown({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection/New/Confirm/Content/Referral/Value/DropDown",
  onChange
  
}) {
let newReferralReferralListValuesValueData = fromData.useDataValue({ viewPath,
context: 'new_referral',
path: 'referral_list_values',
})
let newReferralTextValueValueData = fromData.useDataValue({ viewPath,
context: 'new_referral',
path: 'text_value',
})
let newReferralTextValueChangeData = fromData.useDataChange({ viewPath,
context: 'new_referral',
path: 'text_value',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 field="value"
 marginTop={0}
 size="medium"
 data="new_referral.referral_list_values"
 from={newReferralReferralListValuesValueData}
 data="new_referral.text_value"
 value={newReferralTextValueValueData}
 onChange={newReferralTextValueChangeData}
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}